import { z } from 'zod';
import {
  BaseResponseSchema,
  firstNameSchema,
  integerIdSchema,
  lastNameSchema,
  waferFingerprintSchema,
} from './primitives.js';
import { UserResponseSchema, InvitationResponseSchema } from './tenant-directory.schemas.js';

export const WaferSearchResultSchema = z.object({
  id: integerIdSchema,
  fingerprintString: waferFingerprintSchema,
  layerName: z.string(),
  ownerFirstName: firstNameSchema.optional(),
  ownerLastName: lastNameSchema.optional(),
  status: z.string(),
  lotId: z.string().optional().nullable(),
  confidence: z.number().optional(),
});

export const WaferSearchRequestSchema = z.object({
  fingerprint: waferFingerprintSchema,
});

export const WaferSearchResponseSchema = BaseResponseSchema.extend({
  data: z.array(WaferSearchResultSchema),
});


export const TenantDashboardStatsSchema = z.object({
  containers: z.object({
    total: z.number().int(),
    available: z.number().int(),
    inUse: z.number().int(),
    maintenance: z.number().int(),
  }),
  wafers: z.object({
    total: z.number().int(),
    available: z.number().int(),
    inProduction: z.number().int(),
    completed: z.number().int(),
  }),
  users: z.object({
    total: z.number().int(),
    active: z.number().int(),
    inactive: z.number().int(),
  }),
  storage: z.object({
    usedGB: z.coerce.number(),
  }),
  trends: z.object({
    containers: z.object({
      change: z.number(),
      period: z.string(),
    }),
    wafers: z.object({
      change: z.number(),
      period: z.string(),
    }),
    users: z.object({
      change: z.number(),
      period: z.string(),
    }),
  }),
});

export const DashboardStatsResponseSchema = BaseResponseSchema.extend({
  data: TenantDashboardStatsSchema,
});


export const CreateUserResponseSchema = BaseResponseSchema.extend({
  data: UserResponseSchema,
});

export const GetUsersResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    users: z.array(UserResponseSchema),
    total: z.number().int(),
    page: z.number().int(),
    limit: z.number().int(),
    totalPages: z.number().int(),
  }),
});

export const GetUserByIdResponseSchema = BaseResponseSchema.extend({
  data: UserResponseSchema,
});

export const UpdateUserResponseSchema = BaseResponseSchema.extend({
  data: UserResponseSchema,
});

export const InviteUserResponseSchema = BaseResponseSchema.extend({
  data: InvitationResponseSchema,
});
// Inferred types
export type CreateUserResponse = z.infer<typeof CreateUserResponseSchema>;
export type CreateUserResponseData = z.infer<typeof CreateUserResponseSchema.shape.data>;
export type DashboardStatsResponse = z.infer<typeof DashboardStatsResponseSchema>;
export type DashboardStatsResponseData = z.infer<typeof DashboardStatsResponseSchema.shape.data>;
export type GetUserByIdResponse = z.infer<typeof GetUserByIdResponseSchema>;
export type GetUserByIdResponseData = z.infer<typeof GetUserByIdResponseSchema.shape.data>;
export type GetUsersResponse = z.infer<typeof GetUsersResponseSchema>;
export type GetUsersResponseData = z.infer<typeof GetUsersResponseSchema.shape.data>;
export type InviteUserResponse = z.infer<typeof InviteUserResponseSchema>;
export type TenantDashboardStats = z.infer<typeof TenantDashboardStatsSchema>;
export type UpdateUserResponse = z.infer<typeof UpdateUserResponseSchema>;
export type WaferSearchRequest = z.infer<typeof WaferSearchRequestSchema>;
export type WaferSearchResponse = z.infer<typeof WaferSearchResponseSchema>;
export type WaferSearchResponseData = z.infer<typeof WaferSearchResponseSchema.shape.data>;
export type WaferSearchResult = z.infer<typeof WaferSearchResultSchema>;
